<template>
  <div class="dialog-root">
    <div class="container">
      <div class="item">
        <div class="label">圈子：</div>
        <div class="val">{{ rowData.content }}</div>
      </div>
      <div class="item">
        <div class="label">发布人：</div>
        <div class="val">{{ rowData.publisherName }}</div>
      </div>
      <div class="item">
        <div class="label">圈子回复：</div>
        <div class="val">
          <div class="infinite-list" v-infinite-scroll="getReplies">
            <div class="msg" v-for="msg in replies" :key="msg.id">
              <div class="content">
                <span class="name">{{ msg.replyerName + '：' }}</span>
                <span>{{ msg.content }}</span>
              </div>
              <div class="time">{{ msg.createTime }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="item">
        <div class="label">圈子回复：</div>
        <div class="val">
          <el-input
            v-model="content"
            type="textarea"
            :rows="3"
            maxlength="500"
            show-word-limit
          ></el-input>
        </div>
      </div>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doReply">确定</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getReplyPageListApi, replyApi } from '@/api/general-manage/social-circle';

export default {
  props: ['rowData'],
  data() {
    return {
      loading: false, // 是否正在加载数据
      replies: [], // 回复列表
      currentPage: 1, // 当前已请求的页码数
      content: '', // 本次回复的内容
    };
  },
  created() {
    this.getReplies();
  },
  methods: {
    /* 获取回复分页数据 */
    getReplies() {
      if (this.loading) return;
      this.loading = true;
      getReplyPageListApi({
        circleId: this.rowData.id,
        current: this.currentPage,
        size: 30,
        showFlag: 1,
      }).then(({ data }) => {
        this.replies = this.replies.concat(data.records);
        this.loading = false;
        this.currentPage++;
      });
    },
    /* 保存 */
    doReply() {
      if (!this.content) {
        this.$message.warning('请输入回复内容!');
        return;
      }
      replyApi({
        circleId: this.rowData.id,
        content: this.content,
      }).then(() => {
        this.$message.success('操作成功!');
        this.doClose();
      });
    },
    /* 取消 */
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-root {
  /* 给按钮的父元素加一个相对定位，方便按钮的布局 */
  position: relative;
  /* 内容容器 */
  .container {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    max-height: 60vh;
    padding: 0 10px;
    overflow: scroll;
  }
  /* 按钮占位区域 */
  .placeholder {
    height: 50px;
  }
  /* 底部固定的按钮区域 */
  .btn {
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    background: #fff;
  }
}

.item {
  width: 100%;
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  .label {
    width: 100px;
    text-align: right;
  }
  .val {
    flex: 1;
    .msg {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 10px;
      .name {
        color: red;
      }
      .content {
        flex: 1;
      }
      .time {
        width: 80px;
      }
    }
  }
}

.infinite-list {
  position: relative;
  width: 100%;
  min-height: 60px;
  max-height: 200px;
  overflow: auto;
}
</style>
